import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationService } from '../../modules/navigation/navigation.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-icon-list',
  templateUrl: './icon-list.component.html',
  styleUrls: ['./icon-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IconListComponent implements OnInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  locationPath: string;

  constructor(
    private _navigationService: NavigationService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this._navigationService.navigationEnds$
      .pipe(takeUntil(this._destroyed))
      .subscribe((url) => {
        this.locationPath = url;
        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
